import actionTypes from '../constants/action-types';

const selectDomain = (domain) => ({
  type: actionTypes.SELECT_DOMAIN,
  payload: { domain },
});

export default selectDomain;
